import { useState, useEffect, useContext, memo } from 'react';
import { useRouter } from 'next/router';
import { Context } from '@/context';
import { Box } from '@mui/material';
import LottieIconComponent, { LOTTIE_ICONS } from '../features/lottie/LottieIconComponent';

// Hook personalizado para manejar los eventos del router
const useRouterLoading = () => {
    const router = useRouter();
    const [isLoadingRoute, setIsLoadingRoute] = useState(false);

    useEffect(() => {
        const handleStart = () => setIsLoadingRoute(true);
        const handleComplete = () => setIsLoadingRoute(false);
        const handleError = () => setIsLoadingRoute(false);

        router.events.on('routeChangeStart', handleStart);
        router.events.on('routeChangeComplete', handleComplete);
        router.events.on('routeChangeError', handleError);

        return () => {
            router.events.off('routeChangeStart', handleStart);
            router.events.off('routeChangeComplete', handleComplete);
            router.events.off('routeChangeError', handleError);
        };
    }, [router]);

    return isLoadingRoute;
};

const SpinnerLayout = memo(({ children }) => {
    const router = useRouter();
    const isLoadingRoute = useRouterLoading();
    const { state } = useContext(Context);
    const isSpinnerVisible = state.app.isSpinnerVisible;

    // Detectar si estamos en páginas de Prisma
    const isPrismaPage = router.asPath.startsWith('/prisma');

    // Determina si el spinner debe mostrarse
    // En páginas de Prisma, solo mostrar spinner si está explícitamente visible (no por navegación)
    const shouldShowSpinner = isPrismaPage
        ? isSpinnerVisible
        : isLoadingRoute || router.isFallback || isSpinnerVisible;

    const numeroRandom = Math.floor(Math.random() * 5) + 1;

    // Selecciona el archivo JSON importado en lugar de usar una ruta
    const getSpinnerData = () => {
        switch (numeroRandom) {
            case 1:
                return LOTTIE_ICONS.SPINNER1;
            case 2:
                return LOTTIE_ICONS.SPINNER2;
            case 3:
                return LOTTIE_ICONS.SPINNER3;
            case 4:
                return LOTTIE_ICONS.SPINNER4;
            case 5:
                return LOTTIE_ICONS.SPINNER5;
            case 6:
                return LOTTIE_ICONS.SPINNER6;
            case 7:
                return LOTTIE_ICONS.SPINNER7;
            case 8:
                return LOTTIE_ICONS.SPINNER8;
            case 9:
                return LOTTIE_ICONS.SPINNER9;
            default:
                return LOTTIE_ICONS.SPINNER1;
        }
    };

    return (
        <>
            {shouldShowSpinner && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        backdropFilter: 'blur(2px)',
                    }}
                >
                    <Box width={120} height={120}>
                        <LottieIconComponent icon={getSpinnerData()} width={120} height={120} />
                    </Box>
                </Box>
            )}
            {children}
        </>
    );
});

SpinnerLayout.displayName = 'SpinnerLayout';

export default SpinnerLayout;
